import OfficesJobSearch from './OfficesJobSearch';

export { type OfficesJobSearchProps } from './OfficesJobSearch';
export default OfficesJobSearch;
